<template>
  <div>
    <div class="container p-0 d-flex flex-column flex-lg-row justify-content-between">
      <div 
        class="mr-lg-3 mb-5 mb-lg-0 w-100 gallery-button" 
        @click="showGallery = !showGallery"
      >
        <div class="video-image-wrapper">
          <div class="video-image-text w-100 h-100">
            <div class="container d-flex flex-column h-100 w-100 justify-content-center align-items-center">
              <p class="video-image-text-welcome">
                {{ countryContent.tourStyle }} in
              </p>
              <p class="video-image-text-country">
                {{ countryContent.title }}
              </p>
              <b-icon
                v-if="isVideo"
                class="th-button-icon video-icon"
                icon="play-circle-fill"
              />
            </div>
          </div>
          <img
            :src="addCdnImageWidth(videoPlaceHolder, 800)"
            alt="thumbnail"
            class="th-body-top-image"
          >
        </div>
      </div>
     
      <div 
        class="mb-5 mb-lg-0 w-100 gallery-button" 
        @click="handleGalleryOpen"
      >
        <div class="video-image-wrapper">
          <div class="video-image-text w-100 h-100">
            <div class="d-flex container-fluid flex-column justify-content-center align-items-center w-100 h-100">
              <p class="video-image-text-places">
                Places you will
              </p>
              <p class="video-image-text-country">
                Visit
              </p>
              <b-icon
                class="th-button-icon"
                icon="camera-fill"
              />
            </div>
          </div>
          <img
            :src="addCdnImageWidth(slideShowHero, 800)"
            alt="places to visit"
            class="th-body-top-image"
          >
        </div>
      </div>
      <Lightbox 
        v-if="getLightboxContent && getLightboxContent.length"
        :images="getLightboxContent"
        :enable-autoplay="true"
        :show="showGallery" 
        @closeEvent="showGallery = !showGallery"
      />
      <ImageModal
        ref="imageModal"
        :touring-hub-item="tourHubItem"
      />
    </div>
  </div>
</template>

<script>
import Lightbox from '../../../../../../partials/light-box/index.vue'
import videoPlaceHolder from '../images/video-placeholder.png'
// import Slider from '../slider/index.vue'
import ImageModal from '../modals/image-modal.vue'
import { addCdnImageWidth } from '@/lib/utilities'
export default {
  components: {
    Lightbox,
    // Slider,
    ImageModal
  },
  props: {
    tourHubItem: {
      type: Object,
      default: null
    },
    countryContent: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      showGallery: false,
      lightboxContent: [],
      slideShowImages: [],
      videoPlaceHolder: 'https://cdn.trailfinders.com/video-placeholder.png',
      slideShowHero:'',
      isVideo : false,
    }
  },
  computed: {
    getLightboxContent () {
      return this.lightboxContent
    },
  },
  mounted () {
    this.getSliderImages()
    this.getVideo()
  },
  methods: {
    addCdnImageWidth,
    handleGalleryOpen () {
      this.$refs.imageModal.showModal();
    },
    getSliderImages () {
      const images = this.tourHubItem.placeData.map((place) => {
        return place.content.heroImage
      })
      this.slideShowImages = images
      if (images && images.length > 2) {
        this.slideShowHero = images[2]
      } else {
        this.slideShowHero = images[images.length - 1]
      }
    },
    getVideo() {
      if (
        this.tourHubItem &&
        this.tourHubItem.countryData &&
        this.tourHubItem.countryData.length
      ) {
        if (
          this.tourHubItem.countryData[0] &&
          this.tourHubItem.countryData[0].content &&
          this.tourHubItem.countryData[0].content.videos &&
          this.tourHubItem.countryData[0].content.videos.length
        ) {
          this.lightboxContent = [
            { src: this.tourHubItem.countryData[0].content.videos[0] },
          ];
          // IMAGE TO BE SET HERE
          this.isVideo = true;
          this.videoPlaceHolder = this.tourHubItem.countryData[0].content.heroImage ? this.tourHubItem.countryData[0].content.heroImage : this.tourHubItem.countryData[0].content.images[0];
        } else if (
          this.tourHubItem.countryData[0].content &&
          this.tourHubItem.countryData[0].content.heroImage
        ) {
          this.isVideo = false;
          this.videoPlaceHolder =
            this.tourHubItem.countryData[0].content.heroImage;
        }
      }
      // if no video, look for the hero image to use.
    },
  }
}
</script>

<style lang="scss">

.th-body-top-image {
  width: 100%;
  max-height: 325px;
  
}
.th-button {
  padding: 15px;
  background-color: #f7f29b;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.th-button-icon {
  font-size: 50px;
  margin-top: 5px;
}
.th-button-placeholder {
  width: 30px;
}
.gallery-button {
  cursor: pointer;
}
.video-image-wrapper {
  position: relative;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.video-image-text {
  position: absolute;
  color: #fff;
  background-color: rgba(0,0,0,0.4);
  
  text-align: center;
  vertical-align: auto;
}
.video-image-text p {
  margin: 0 !important;
  padding: 0 !important;
  text-align: center !important;
}
.video-image-text-welcome {
  font-size: 30px !important;
}
.video-image-text-places {
  font-size: 30px !important;
}
.video-image-text-country {
  font-size: 50px !important;
}

@media (max-width: 800px) {
  .video-image-text p {
    font-size: 2rem !important;
  }
}
@media (max-width: 430px) {
  .video-image-text p {
    font-size: 1rem !important;
  }
}

.justify-content-between{
  justify-content: space-between !important;
}
</style>
